import {startsWith} from 'lodash';
import validator from 'validator';

export const mailto = 'mailto:';
export const isEmail = (val: string) => startsWith(val, mailto);
const tel = 'tel:';
const isTel = (val: string) => startsWith(val, tel);

export const isValidRelativeLink = (val: string) =>
  /^[a-zA-Z0-9\/#?&=_][a-zA-Z0-9\-\/#?&=_]*$/.test(val);

export const isValidLink = (val: string) => {
  return (
    (isEmail(val) && validator.isEmail(val.slice(mailto.length))) ||
    isTel(val) ||
    validator.isURL(val.replace(/^file:\/\/(\/?)/, 'http://localhost$1'), {
      protocols: ['http', 'https', 'ftp'],
      require_tld: false,
      allow_underscores: true,
    }) ||
    isValidRelativeLink(val)
  );
};

/**
 * Validates a user-provided display name (e.g. a person's first/last name).
 * Rejects values containing a URL, since those get auto-linkified when the name
 * is rendered in emails. Shared by server-side signup/profile validation
 * (re-exported from @packages/utilities/config-helper) and client-side input
 * validation, so the rule stays in one place.
 */
export const isValidName = function (name?: string | null): boolean {
  if (!name) {
    return true;
  }
  if (/https?:\/\//i.test(name)) {
    return false;
  }
  return true;
};
